import React from "react";
import { notifyError } from "./notifyError";

export class AppErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("GLOBAL CRASH:", error, errorInfo);
    notifyError("App error occurred. Reload recommended.");
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <section className="flex items-center justify-center h-screen">
          <section className="text-center">
            <h1 className="mb-8 text-5xl font-extrabold text-gray-800">
              Something went wrong
            </h1>
            <p className="mb-5 text-2xl font-medium">
              The application encountered an unexpected error. Please reload to
              continue.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              className="px-5 py-4 text-xl text-white rounded-md shadow-lg bg-secondaryColor"
            >
              Reload App
            </button>
          </section>
        </section>
      );
    }

    return this.props.children;
  }
}
